module.exports = __webpack_public_path__ + "static/media/check_icon.90fd1822.svg";